import PropTypes from 'prop-types';
import { Component } from 'react';

// @ts-expect-error needs types
import ApiExplorer from './ApiExplorer';
import HR from 'UIComponents/elements/HR';
// @ts-expect-error needs types
import Markdown from './Markdown';
import { mutateTrackerInstance } from '../../../tracking/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
class DeveloperDoc extends Component {
  render() {
    const {
      specWithExtensions,
      oasDocs,
      newLayout,
      headerId,
      usageTracker
    } = this.props;
    const mutatedTracker = mutateTrackerInstance(usageTracker);
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [!newLayout && specWithExtensions.info.description && /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Markdown, {
          children: specWithExtensions.info.description
        }), /*#__PURE__*/_jsx(HR, {})]
      }), /*#__PURE__*/_jsx(ApiExplorer, {
        oasDocs: oasDocs,
        oasFiles: {
          'api-setting': specWithExtensions
        },
        flags: {
          correctnewlines: false
        },
        newLayout: newLayout,
        headerId: headerId,
        usageTracker: mutatedTracker
      })]
    });
  }
}
DeveloperDoc.propTypes = {
  oasDocs: PropTypes.array,
  specWithExtensions: PropTypes.object,
  newLayout: PropTypes.bool,
  usageTracker: PropTypes.object.isRequired
};
export default DeveloperDoc;